// utils/redirectHelper.js

export default {
    storageKey: "redirectUrl",

    /**
     * 保存当前页面 URL 到 sessionStorage
     * 排除掉单点登录回调页面
     */
    saveCurrentUrl() {
        const currentUrl = new URL(window.location.href);
        if (!currentUrl.pathname.includes("auth/single-login")) {
            sessionStorage.setItem(this.storageKey, window.location.href);
        }
    },

    /**
     * 使用 Vue Router 跳转到保存的 URL
     * 如果没有保存过 URL，则跳转到默认页面
     * @param {Object} router - Vue Router 实例
     * @param {String} defaultPath - 默认跳转路径 (比如 "/dashboard")
     */
    redirectToSavedUrl(router, defaultPath = "/dashboard") {
        const redirectUrl = sessionStorage.getItem(this.storageKey);

        if (redirectUrl) {
            try {
                const url = new URL(redirectUrl);
                router.push({
                    path: url.pathname,
                    query: Object.fromEntries(url.searchParams),
                    hash: url.hash,
                });
                return;
            } catch (err) {
                console.error("Invalid redirectUrl:", redirectUrl, err);
            }
        }

        // 如果没有 redirectUrl，就跳转默认页
        router.push(defaultPath);
        this.clear();
    },

    /**
     * 清除保存的 URL
     */
    clear() {
        sessionStorage.removeItem(this.storageKey);
    },
};
